import { useContext } from 'react';
import { AssessmentContext } from './assessmentContext';
import { getQuestionNumber } from 'utils';
export const useAssessmentContext = () => {
  if (!AssessmentContext) {
    throw new Error(
      'useAssessmentContext must be used within an AssessmentProvider'
    );
  }

  const { state, dispatch } = useContext(AssessmentContext);
  const { assessmentAttempt, currentSectionIndex, currentSlotIndex } = state;
  let currentSection;
  let currentSlot;
  let currentQuestionNumber;
  let disableScreenWarnings =
    assessmentAttempt?.assessment?.configuration?.disable_screen_warnings;

  // We need to parse the array because its reaching our server as a string
  // e.g "['value','value']"
  // /'|\[|\]|\s+/g with this regex pattern, we can remove ' [ and ] in one replace
  if (typeof disableScreenWarnings === 'string') {
    try {
      disableScreenWarnings = disableScreenWarnings
        .replace(/'|\[|\]|\s+/g, '')
        .split(',');
    } catch (error) {
      console.error('Failed to parse disableScreenWarnings:', error);
      disableScreenWarnings = [];
    }
  }

  if (Number.isInteger(currentSectionIndex)) {
    currentSection = assessmentAttempt?.section_attempts[currentSectionIndex];
  }

  if (Number.isInteger(currentSlotIndex)) {
    currentSlot = currentSection?.slot_attempts[currentSlotIndex];
  }
  if (currentSection && currentSlot) {
    currentQuestionNumber = getQuestionNumber(
      currentSection,
      currentSlot.sort_index
    );
  }
  return {
    state,
    dispatch,
    assessmentAttempt,
    currentSection,
    currentSlot,
    currentQuestionNumber,
    disableScreenWarnings
  };
};
